import { ValidationResult } from '../form-validation'
import moment from 'moment'

export const dateValidator = (date: string | null) : ValidationResult => {
    if (date === 'invalid') {
        return {
            valid: false
        }
    }

    if (date && (moment(date).isBefore(moment('1900-01-01')) || moment(date).isAfter(moment()))) {
        return {
            valid: false
        }
    }
    
    return {
        valid: true
    }
}
